export default function FaqHeroSection() {
  return (
    <section
      className="relative flex items-center justify-center overflow-hidden"
      style={{ paddingTop: '72px', minHeight: '420px' }}
    >
      <div className="absolute inset-0">
        <img
          src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/faq-hero1.jpg"
          alt="よくある質問 - 安心のご相談環境"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0" style={{ background: 'rgba(74,55,40,0.52)' }} />
      </div>
      <div className="relative z-10 w-full content-width text-center py-20">
        <div className="animate-fadeIn">
          <p
            className="inline-block px-4 py-1 rounded-full mb-5 text-sm font-bold"
            style={{ background: 'rgba(255,255,255,0.2)', color: '#f5d9b8', border: '1px solid rgba(255,255,255,0.4)' }}
          >
            よくある質問
          </p>
          <h1 className="text-white mb-6" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>
            よくある質問
          </h1>
          <p className="text-white/90 mx-auto max-w-2xl" style={{ fontSize: '18px', lineHeight: '1.8' }}>
            入会やサービスについての疑問・不安を解消いたします。<br className="hidden sm:block" />
            ご不明な点はお気軽にお問い合わせください。
          </p>
        </div>
      </div>
    </section>
  );
}
